import { useState, useEffect, useRef } from "react";
import { generaTablaAmortizacion } from "../functions/generaTablaAmortizacion";

const useTableAmortization = ({
  loanAmount,
  interestRate,
  loanTerm,
  creditDownPayment,
  paymentDay
}) => {
  const [data, setData] = useState([]);
  const prevRef = useRef({});

  // Recalcular automáticamente cuando cambian los valores relevantes
  useEffect(() => {
    const amount = parseFloat(loanAmount) || 0;
    const term = parseInt(loanTerm) || 0;
    const downPayment = parseFloat(creditDownPayment) || 0;

    // Solo calcular si tenemos los valores mínimos necesarios
    if (amount > 0 && term >= 1 && paymentDay) {
      // Evitar recálculos innecesarios
      const key = `${amount}-${term}-${downPayment}-${paymentDay}`;
      if (prevRef.current.key === key) return;
      prevRef.current.key = key;

      setData(
        generaTablaAmortizacion(amount, downPayment, term, paymentDay, interestRate || 0)
      );
    } else {
      setData([]);
    }
  }, [loanAmount, interestRate, loanTerm, creditDownPayment, paymentDay]);

  const calculatePayments = () => {
    const amount = parseFloat(loanAmount) || 0;
    const term = parseInt(loanTerm) || 0;
    const downPayment = parseFloat(creditDownPayment) || 0;

    if (amount > 0 && term >= 1 && paymentDay) {
      setData(
        generaTablaAmortizacion(amount, downPayment, term, paymentDay, interestRate || 0)
      );
    }
  };

  return {
    calculatePayments,
    data,
    setData
  };
};

export default useTableAmortization;
